import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { SpaceSection } from './components/SpaceSection';
import { CollectionSection } from './components/CollectionSection';
import { JoinSection } from './components/JoinSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative min-h-screen w-full selection:bg-pink-200 selection:text-black" data-id="element-0">
      {/* Fixed Iridescent Background */}
      <div className="fixed inset-0 z-[-1] pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/t5LhwpD1iUZBbuktJp1Gek/Fondo_Gloss.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }} data-id="element-1" />

      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <SpaceSection data-id="element-7" />
        <CollectionSection data-id="element-8" />
        <JoinSection data-id="element-9" />
        <FaqSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}